import React from 'react'
import style from './index.module.scss'
const ProductionTotal = (props) => {
    const {
        gasProductWeek,
        gasProductMonth,
        gasProductYear,
        ethaneProductWeek,
        ethaneProductMonth,
        ethaneProductYear,
        propaneProductWeek,
        propaneProductMonth,
        propaneProductYear,
        butaneProductWeek,
        butaneProductMonth,
        butaneProductYear,
        olefinProductWeek,
        olefinProductMonth,
        olefinProductYear,
    } = props;
    return (
        <div className={style['bigProductionTotal']}>
            <div className="bigProductionTotal-title">生产汇总</div>
            <ul className="bigProductionTotal-list">
                <li>
                    <span className="thead name">产品</span>
                    <span className="thead">周累</span>
                    <span className="thead">月累</span>
                    <span className="thead">年累</span>
                </li>
                <li>
                    <span className="name">
                        <span className="energy">干气</span>
                        <span className="type">万Nm³</span>
                    </span>
                    <span>{gasProductWeek}</span>
                    <span>{gasProductMonth}</span>
                    <span>{gasProductYear}</span>
                </li>
                <li>
                    <span className="name">
                        <span className="energy">乙烷</span>
                        <span className="type" style={{marginLeft:20}}>万Nm³</span>
                    </span>
                    <span>{ethaneProductWeek}</span>
                    <span>{ethaneProductMonth}</span>
                    <span>{ethaneProductYear}</span>
                </li>
                <li>
                    <span className="name">
                        <span className="energy">丙烷</span>
                        <span className="type" style={{marginLeft:22}}>t</span>
                    </span>
                    <span>{propaneProductWeek}</span>
                    <span>{propaneProductMonth}</span>
                    <span>{propaneProductYear}</span>
                </li>
                <li>
                    <span className="name">
                        <span className="energy">丁烷</span>
                        <span className="type" style={{marginLeft:22}}>t</span>
                    </span>
                    <span>{butaneProductWeek}</span>
                    <span>{butaneProductMonth}</span>
                    <span>{butaneProductYear}</span>
                </li>
                <li>
                    <span className="name">
                       <span className="energy">轻油</span>
                       <span className="type" style={{marginLeft:22}}>t</span>
                    </span>
                    <span>{olefinProductWeek}</span>
                    <span>{olefinProductMonth}</span>
                    <span>{olefinProductYear}</span>
                </li>
            </ul>
        </div>
    )
}
export default ProductionTotal
